import {createStore} from 'vuex'

export default createStore({
    state: {
        token: ''||localStorage.getItem('token'),
        tagsList: [],
        collapse: false,
        webSocket:{
            notifyObject:"",
            message:[],
            messageExcells:[],
            messageRead:true,
            messageExcellReadS:true
        },
    },
    mutations: {
        delTagsItem(state, data) {
            state
                .tagsList
                .splice(data.index, 1);
        },
        setTagsItem(state, data) {
            state
                .tagsList
                .push(data)
        },
        clearTags(state) {
            state.tagsList = []
        },
        closeTagsOther(state, data) {
            state.tagsList = data;
        },
        closeCurrentTag(state, data) {
            for (let i = 0, len = state.tagsList.length; i < len; i++) {
                const item = state.tagsList[i];
                if (item.path === data.$route.fullPath) {
                    if (i < len - 1) {
                        data
                            .$router
                            .push(state.tagsList[i + 1].path);
                    } else if (i > 0) {
                        data
                            .$router
                            .push(state.tagsList[i - 1].path);
                    } else {
                        data
                            .$router
                            .push("/");
                    }
                    state
                        .tagsList
                        .splice(i, 1);
                    break;
                }
            }
        },
        // 侧边栏折叠
        hadndleCollapse(state, data) {
            state.collapse = data;
        },
        // webSocket
        setWebSocket(state, info) {
            console.log(info);
            let obj ={api:info}
            //创建一个新的对象，将state.shareInformation，Info，对象复制到新对象中
            let data = Object.assign({},state.webSocket.notifyObject,obj);
            //将state.shareInformation指向新对象的引用地址
            state.webSocket.notifyObject = data;
        },
        // 当前通知类型
        setMessage(state, data) {
            state.webSocket.message.push(data);
        },
        // 设置是否已读
        setMessageRead(state, data) {
            state.webSocket.messageRead=data;
        },
        setMessageExcell(state, data) {
            state.webSocket.messageExcells.push(data);
        },
        // 设置下载Excell是否已读
        setMessageReadExcell(state, data) {
            state.webSocket.messageExcellReadS=data;
        },
    },
    actions: {},
    modules: {}
})
